/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Generated_Badge_LabelInputs */

const en_ai_generated_badge_label = /** @type {(inputs: Ai_Generated_Badge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-generated`)
};

const de_ai_generated_badge_label = /** @type {(inputs: Ai_Generated_Badge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-generiert`)
};

const fr_ai_generated_badge_label = /** @type {(inputs: Ai_Generated_Badge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Généré par l’IA`)
};

const es_ai_generated_badge_label = /** @type {(inputs: Ai_Generated_Badge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generado por IA`)
};

const it_ai_generated_badge_label = /** @type {(inputs: Ai_Generated_Badge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generato dall’IA`)
};

const nl_ai_generated_badge_label = /** @type {(inputs: Ai_Generated_Badge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Door AI gegenereerd`)
};

const pl_ai_generated_badge_label = /** @type {(inputs: Ai_Generated_Badge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wygenerowane przez AI`)
};

const fi_ai_generated_badge_label = /** @type {(inputs: Ai_Generated_Badge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekoälyn tuottama`)
};

const da_ai_generated_badge_label = /** @type {(inputs: Ai_Generated_Badge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-genereret`)
};

const sv_ai_generated_badge_label = /** @type {(inputs: Ai_Generated_Badge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-genererat`)
};

/**
* | output |
* | --- |
* | "AI-generated" |
*
* @param {Ai_Generated_Badge_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ai_generated_badge_label = /** @type {((inputs?: Ai_Generated_Badge_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Generated_Badge_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_generated_badge_label(inputs)
	if (locale === "fr") return fr_ai_generated_badge_label(inputs)
	if (locale === "es") return es_ai_generated_badge_label(inputs)
	if (locale === "it") return it_ai_generated_badge_label(inputs)
	if (locale === "nl") return nl_ai_generated_badge_label(inputs)
	if (locale === "pl") return pl_ai_generated_badge_label(inputs)
	if (locale === "fi") return fi_ai_generated_badge_label(inputs)
	if (locale === "da") return da_ai_generated_badge_label(inputs)
	if (locale === "sv") return sv_ai_generated_badge_label(inputs)
	return en_ai_generated_badge_label(inputs)
});